import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Procedure } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import EditProcedure from './EditProcedure.vue';

    interface Props {
        procedure: Procedure;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProceduresTableActions',
  props: {
    procedure: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.procedure }, {
    default: _withCtx(() => [
      _createVNode(EditProcedure, { procedure: _ctx.procedure }, null, 8, ["procedure"])
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})